import React from 'react';

// German Impressum (§ 5 TMG / § 18 Abs. 2 MStV). Rendered inside the black
// overlay with the same .overlay-legal styling as the GDPR text.
export default () => (
  <div className="column">
    <h1>Impressum</h1>
    <h2>Angaben gemäß § 5 TMG</h2>
    <p>
      Camill von Egloffstein<br/>
      Sommerstraße 24<br/>
      81543 München
    </p>
    <h2>Kontakt</h2>
    <p>
      E-Mail: <a href="mailto:camillvegloffstein@icloud.com">camillvegloffstein@icloud.com</a>
    </p>
    <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
    <p>
      Camill von Egloffstein<br/>
      Sommerstraße 24<br/>
      81543 München
    </p>
  </div>
);
